import { ApiClient } from './interceptor';

const api = ApiClient.getInstance();

export const getExpotedLeads = async () => {
  return await api.get('leads/export');
};
